<template>
  <div class="video-wrapper">
    <video
      ref="video"
      :controls="controls"
      loop
      autoplay
      playsinline
      :muted="muted"
      :poster="poster"
    >
      <source :type="type" />
      Your browser does not support the video tag.
    </video>

    <div class="video-mute"></div>
  </div>
</template>

<script setup>
import { useElementVisibility } from '@vueuse/core';
import { useTemplateRef, watch } from 'vue';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },

  type: {
    type: String,
    default: 'video/mp4',
  },

  controls: {
    type: Boolean,
    default: false,
  },

  poster: {
    type: String,
    default: '',
  },

  play: {
    type: Boolean,
    default: false,
  },

  muted: {
    type: Boolean,
    default: true,
  },
});

const video = useTemplateRef('video');
const videoIsVisible = useElementVisibility(video);

watch(
  () => props.play,
  async () => {
    if (video.value?.src) {
      try {
        if (props.play) {
          await video.value.play();
        } else {
          video.value.pause();
        }
      } catch (err) {
        console.warn('Ошибка при воспроизведении:', err);
      }
    }
  }
);

watch(videoIsVisible, async (val) => {
  if (val && !video.value.src) {
    video.value.src = props.src;
  }

  if (video.value.src) {
    try {
      if (props.play) {
        await video.value.play();
      } else {
        video.value.pause();
      }
    } catch (err) {
      console.warn('Ошибка при воспроизведении:', err);
    }
  }
});
</script>

<style lang="scss">
.video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .video-mute {
  }
}
</style>
